import { Component, Input } from '@angular/core';
import { StudyArea } from '../../interfaces/study-area';

@Component({
  selector: 'app-study-area-details',
  templateUrl: './study-area-details.component.html',
  styleUrls: ['./study-area-details.component.scss']
})
export class StudyAreaDetailsComponent {
  @Input() studyArea: StudyArea | null = null;
}
